import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const FAQ: React.FC = () => {
  return (
    <section className="bg-muted/30 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl font-bold text-center mb-12">
          Frequently asked questions about DiskOver
        </h2>
        
        <Accordion type="single" collapsible className="space-y-4">
          <AccordionItem value="item-1" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              What is DiskOver?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              DiskOver is a cultural podcast platform that allows you to discover the history and culture of fascinating places through short audio podcasts. You can also create your own podcasts and share your cultural discoveries. The goal is to create the platform centralizing all the information you need to know to visit a place.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              How to explore podcasts by region?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Each podcast is associated with precise geographical coordinates. Thanks to our interactive map, you can visually explore content available near you or anywhere in the world. Podcasts are displayed as markers on the map.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              In which languages are the podcasts available?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Podcasts are currently available in French and English only. More languages are coming soon. You can easily switch between languages according to your preferences. Some places may only have content in one language, but we encourage the creation of multilingual versions.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              How can I create my own podcast on DiskOver?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Creating a podcast is simple: click on the 'Create a podcast' button, search for a place on the map, select your language, and we will create cultural content for it in less than one minute. This allows everyone to discover that place.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-5" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              Are DiskOver podcasts free?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Yes, listening to podcasts is completely free. However, creating podcasts requires a free registration, which helps us limit abuse but above all allows us to offer you more features. Our mission is to make culture accessible to everyone.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-6" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              Can I use DiskOver offline?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Podcasts can currently be listened to via streaming only. For offline use, we are working on a feature that will allow you to download them. The interactive map requires an internet connection to function optimally.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-7" className="bg-background rounded-lg border">
            <AccordionTrigger className="px-6 text-left">
              Why do I need to sign in to create podcasts?
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6">
              Signing in allows us to track the podcasts created by each user, so that if they use the app for personal purposes or publish content on irrelevant places, we can intervene. The goal is to ensure an enriching experience for the whole community.
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        {/* Structured Data for FAQ */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is DiskOver?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "DiskOver is a cultural podcast platform that allows you to discover the history and culture of fascinating places through short 3-minute audio stories."
                }
              },
              {
                "@type": "Question", 
                "name": "How to explore podcasts by region?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Each podcast is associated with precise geographical coordinates. Thanks to our interactive map, you can visually explore content available near you or anywhere in the world. Podcasts are displayed as markers on the map."
                }
              },
              {
                "@type": "Question",
                "name": "In which languages are the podcasts available?", 
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Podcasts are currently available in French and English only. More languages are coming soon. You can easily switch between languages according to your preferences. Some places may only have content in one language, but we encourage the creation of multilingual versions."
                }
              },
              {
                "@type": "Question",
                "name": "How can I create my own podcast on DiskOver?",
                "acceptedAnswer": {
                  "@type": "Answer", 
                  "text": "Creating a podcast is simple: click on the 'Create a podcast' button, search for a place on the map, select your language, and we will create cultural content for it in less than one minute. This allows everyone to discover that place."
                }
              },
              {
                "@type": "Question",
                "name": "Are DiskOver podcasts free?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, listening to podcasts is completely free. However, creating podcasts requires a free registration, which helps us limit abuse but above all allows us to offer you more features. Our mission is to make culture accessible to everyone."
                }
              },
              {
                "@type": "Question",
                "name": "Why do I need to sign in to create podcasts?",
                "acceptedAnswer": {
                  "@type": "Answer", 
                  "text": "Signing in allows us to track the podcasts created by each user, so that if they use the app for personal purposes or publish content on irrelevant places, we can intervene. The goal is to ensure an enriching experience for the whole community."
                }
              }
            ]
          })
        }} />
      </div>
    </section>
  );
};

export default FAQ;